module.exports = __webpack_public_path__ + "static/media/6.e92ee21e.mp3";